import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';
import { SideBarMode, SidebarSection } from '@/modules/corporate/modules/admin/hooks/useSidebar';

import SidebarItem from './SidebarItem';

const Section = ({
  section,
  mode,
  className,
}: {
  section: SidebarSection;
  mode?: SideBarMode;
  className?: string;
}) => {
  return (
    <Box className={cn(section?.className, className)}>
      {!!section.node && <Stack>{section.node}</Stack>}
      {section.children.map((sidebarItem) => (
        <SidebarItem key={sidebarItem.id} mode={mode} sidebarItem={sidebarItem} />
      ))}
    </Box>
  );
};

export default Section;
